export default {"src":"/_next/static/media/more-contact-info.b0d2a621.svg","height":24,"width":24};